var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeedle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63.74 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #95B4BC;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Objects"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.6,51.32l.1-.1c.37-.31.71-.65,1.02-1.01L63.59.84c.42-.41-.12-1.08-.61-.76L4.64,38.13c-.41.18-.81.4-1.19.66l-.13.07h0c-.07.06-.14.1-.21.15-3.44,2.56-4.15,7.43-1.59,10.86,2.56,3.44,7.43,4.15,10.86,1.59.07-.05.13-.11.19-.16h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedle);
export default __webpack_public_path__ + "static/media/needle.83bb0a360c7518874088b7ab6b836c4e.svg";
export { ForwardRef as ReactComponent };